import { NationalMenuTileData } from './types';

const IMG_DOMAIN = 'https://www.pizzahut.com';

const MYHUTBOX_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/MHB_Maindealtile_175x203.jpg`;
const PPP_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/PersonalPanPizza_ProductTile_Web_175x203.jpg`;
const MEAT_LOVERS_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_ProductTile_MeatLoversMelt_Web_175x203.jpg`;
const CHICKEN_BACON_PARM_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_ProductTile_ChickenBaconParmMelt_Web_175x203.jpg`;
const BUFFALO_CHICKEN_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_Product_BuffaloChickenMelt_Web_175x203v2.jpg`;
const PEPPERONI_LOVERS_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_ProductTile_PepLoverMelt_Web_175x203.jpg`;

const partyofone: Array<NationalMenuTileData> = [
  {
    id: 'partyofone1',
    name: 'My Hut Box',
    mobileImageUrl: MYHUTBOX_IMG,
    desktopImageUrl: MYHUTBOX_IMG,
    productDescription: 'NEW! My Hut Box - Make it yours with choice of entrée & side',
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'partyofone2',
    name: 'Personal Pan Pizza®',
    mobileImageUrl: PPP_IMG,
    desktopImageUrl: PPP_IMG,
    productDescription: 'Everything you love about our classic Original Pan® Pizza, sized just for you. Our Personal Pan Pizza® is a 6-inch pizza with a crust that\'s crispy on the outside & fluffy on the inside.',
    priority: 1,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'partyofone3',
    name: 'Meat Lover’s® Melt',
    mobileImageUrl: MEAT_LOVERS_IMG,
    desktopImageUrl: MEAT_LOVERS_IMG,
    productDescription: 'A Melt loaded with pepperoni, ham, Italian sausage, pork, beef, bacon and cheese. Served with marinara for dipping. Comes with one dipping sauce; no substitutions.',
    priority: 2,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'partyofone4',
    name: 'Chicken Bacon Parmesan Melt',
    mobileImageUrl: CHICKEN_BACON_PARM_IMG,
    desktopImageUrl: CHICKEN_BACON_PARM_IMG,
    productDescription: 'A Melt loaded with chicken, bacon, creamy Alfredo sauce and cheese. Served with ranch for dipping. Comes with one dipping sauce; no substitutions.',
    priority: 3,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'partyofone5',
    name: 'Buffalo Chicken Melt',
    mobileImageUrl: BUFFALO_CHICKEN_IMG,
    desktopImageUrl: BUFFALO_CHICKEN_IMG,
    productDescription: 'A Melt loaded with chicken, onion, buffalo sauce and cheese. Served with ranch for dipping. Comes with one dipping sauce; no substitutions.',
    priority: 3,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'partyofone6',
    name: 'Pepperoni Lover’s® Melt',
    mobileImageUrl: PEPPERONI_LOVERS_IMG,
    desktopImageUrl: PEPPERONI_LOVERS_IMG,
    productDescription: 'A Melt loaded with pepperoni and cheese. Served with marinara for dipping. Comes with one dipping sauce; no substitutions.',
    priority: 3,
    vegetarian: false,
    handleClick: () => {}
  }
];

export default partyofone;
